import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6555ce8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-area" }
const _hoisted_2 = { class: "top-image" }
const _hoisted_3 = { class: "all-image left-image" }
const _hoisted_4 = { class: "all-image right-image" }
const _hoisted_5 = { class: "b-image" }
const _hoisted_6 = { class: "b-image-s" }
const _hoisted_7 = {
  ref: "mapInfo",
  id: "amp-container",
  class: "mapInfo"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "info" }, null, -1))
const _hoisted_9 = ["value"]

import { TUICallKit,TUICallKitServer,TUICallKitMini } from "../components/TUICallKit/Web";
import {onMounted, reactive, ref,onBeforeMount,onBeforeUnmount} from "vue"
import {post} from "../utils/post"
import {areaData, controlData} from "./data"
interface obj {
  [index: string]: {
    position: any,
    phone: any,
    content: any
  };
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const SDKAppID = 1400796494; // Your SDKAppID
const secretKey = '427b876e7bfaffde6147a3ec8a7ef24606318fef759d88597bec0b51eb66c532'; //Your secretKey
const userID = 'change003'; // User ID
const userSig = "eJwtzM0KgkAYheF7mXXIl85PI7SzEAslHGktzaRfQzKalRDde6Yuz3Pg-RB1zL2X6UhIfA-IatqoTdPjFSe*1GVTGYBgOR-als6hJuGaAgjJqaTzYwaHnRmdMeYDwKw93v-GxQZ4IIW-VLAa212bmTiNo1ZXdRY9bZ0d9lYX5yTdvaNE6lM*uOKWKlTFlnx-7ykzIA__"
console.log(areaData,"=========")
// init TUIKit
TUICallKitServer.init({ SDKAppID, userID, userSig });
let infoWindow : any;
let showModal = ref(0);

let interval:any;

let infoWindowData : obj = {};//储存 infowindow弹框
let userId: any;//储存当前窗口电话
/**
 * 拨打电话
 */
const callPhone = () => {
  showModal.value = 1;
  console.log(userId)
  TUICallKitServer.call({ userID: userId, type: 2 }); // 双人通话
}
/**
 * 通话前回调
 */
const beforeCalling = () => {
  showModal.value = 1;
}
/**
 * 通话后回调
 */
const afterCalling = () => {
  showModal.value = 0;
  if(infoWindow){
    infoWindow.close();
  }
}

onMounted(() => {
  init()
  onBeforeMount(() => {
    document.body.setAttribute("style", "height: 110%");
  });
})

const dataMap = reactive({
  map: '',
  markerLayer: '',
  latitude: '', //纬度
  lngitude: '', //经度
  address: ''
})
const TMap = (window as any).TMap
let marker : any;
let center = new TMap.LatLng('37.2035', '115.46') //设置地图中心点坐标
let zoom = 17.5 //设置地图缩放级别
//初始化地图
const init = () => {
  dataMap.map = new TMap.Map(document.getElementById('amp-container'), {
    center: center, //设置地图中心点坐标
    zoom: zoom, //设置地图缩放级别
    viewMode: '2D',
    mapStyleId: 'style2',
    renderOptions: {
      enableBloom: true, // 泛光
    },
    baseMap: {
      type: "vector",
      features: ["base", "building3d"], // 隐藏矢量文字
    },
    pitch: 0,
    showControl:false
  })

  //------------2、边界围墙开始------------------

  let wallLine = [
    [37.20658401822, 115.45853079595679],
    [37.20582370395616, 115.45826264659615],
    [37.20333767960822, 115.45764054076051],
    [37.2033803955244, 115.45731876178968],
    [37.20027915921542, 115.4567610109624],
    [37.199980135693146, 115.46550267720511],
    [37.20424325122935, 115.46550267720511],
    [37.20438848329462, 115.46255303538408],
    [37.20508901117501, 115.46160914975906],
    [37.20660110345023, 115.46181294321093],
    [37.20663527494219, 115.45853079595679],
    [37.20658401822, 115.45853079595679],
  ];

  let path = convertToPath(wallLine);
  let wallData = {
    path: path, //	经纬度数组
    height: 5, //围墙面高度
    styleId: "style1", //围墙面样式配置id
  };
  //初始化围墙线
  let Wall = new TMap.visualization.Wall({
    styles: {
      style1: {
        color: new TMap.GradientColor({
          stops: {
            0: "rgba(1,124,247,0.6)",
            1: "rgba(29,250,242,1)",
          },
          angle: 90, //渐变色中的断点集合
        }),
        strokeColor: 'rgba(29,250,242,1)', //边线颜色
        strokeWidth: 2, //边线宽度
      },
    },
    processAnimation: {
      animationType: "breath", //动画类型名称
      breathAmplitude: 0.5, //呼吸幅度
      yoyo: true, //是否回弹
      duration: 1000, //动画时长
    },

  }).addTo(dataMap.map)
  Wall.setData([wallData]);
  controlData.forEach((control : {position:any }) => {
    control.position = new TMap.LatLng(control.position[0], control.position[1])
  })
  //---------监控坐标点标注---开始-------------------------
  // marker文字在图片外  MultiMarker文档地址：https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocMarker
  const controlMarker = new TMap.MultiMarker({
    map: dataMap.map, // 显示Marker图层的底图
    styles: {
      small: new TMap.MarkerStyle({
        // 点标注的相关样式
        width: 34, // 宽度
        height: 46, // 高度
        anchor: { x: 17, y: 23 }, // 标注点图片的锚点位置
        src: 'data:image/png;base64,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',
        // src: 'https://www.meiyun.cc/img/small_r.png', //  标注点图片url或base64地址
        color: '#333', // 标注点文本颜色
        size: 16, // 标注点文本文字大小
        direction: 'bottom', // 标注点文本文字相对于标注点图片的方位
        offset: { x: 0, y: 8 }, // 标注点文本文字基于direction方位的偏移属性
        strokeColor: '#fff', // 标注点文本描边颜色
        strokeWidth: 2, // 标注点文本描边宽度
      }),
      big: new TMap.MarkerStyle({
        width: 58,
        height: 76,
        anchor: { x: 36, y: 32 },
        src: 'https://mapapi.qq.com/web/lbs/visualizationApi/demo/img/big.png',
        color: '#333',
        size: 22,
        direction: 'bottom',
        strokeColor: '#fff',
        offset: { x: 0, y: 10 },
        strokeWidth: 2,
      }),
    },
    enableCollision: true, // 开启碰撞
    geometries: controlData,
  });
  controlMarker.on("click",(event: { geometry: { position: { toString: () => any; };id: any }; }) => {
    console.log(event.geometry,"===========")
    // window.open("https://baidu.com")
  })

  // ---------监控坐标点标注---结束----------------------------

  //------------房子开始--总--------------
  const info = document.getElementById("info");
  let paths:any = [];

  //房子样式
  areaData.forEach((item, index) => {
    if(index < 5) {
      paths.push({
        path: item, //设置区域边界线经纬度点串
        styleId: 'styel3' //设置区域样式id
      })
    } else if(index % 3 === 1) {
      paths.push({
        path: item, //设置区域边界线经纬度点串
        styleId: 'styel1' //设置区域样式id
      })
    } else if(index % 3 ===2) {
      paths.push({
        path: item, //设置区域边界线经纬度点串
        styleId: 'styel2' //设置区域样式id
      })
    } else {
      paths.push({
        path: item, //设置区域边界线经纬度点串
        styleId: 'styel1' //设置区域样式id
      })
    }
  })
  let area = new TMap.visualization.Area({
    styles: { //设置区域图样式
      styel1: setStyles(0.8),
      styel2: setStyles(0.5),
      styel3: setStyles(0.2),
    },
  }).setData(paths).addTo(dataMap.map);
  markerLayer();
}

// 房子样式--子--- 设置style样式工厂函数
const setStyles = (opacity:any) => {
  return {
    fillColor: `rgba(56,124,234,${opacity})`, //设置区域填充颜色
    strokeColor: '#6799EA', //设置区域边线颜色
  }
}

const convertToPath = (array:any) => {
  return array.map((p:any) => {
    if (p.length == 2) return new TMap.LatLng(p[0], p[1]);
    if (p.length == 3) return new TMap.LatLng(p[0], p[1], p[2]);
  });
}

const markerLayer = async () => {
  if(infoWindow){
    infoWindow.close();
  }
  const result:any = await post('home/WxApp/getAllUserLocation')
  if(result.errorCode != 0) {
    console.log(result)
    return false
  }
  const userList = result.data;
  let maxId = userList[userList.length - 1].id;
  let  geometries: {
      id: any; //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
      styleId: string; //指定样式id
      tip: any,
      properties: any,
      position: any; //点标记坐标位置
  }[] = [
    {
      "id": maxId + 100,
      "styleId": 'marker1',
      "position": new TMap.LatLng(37.20400735037333, 115.46126012628055),
      "tip": "<div><img src='https://www.meiyun.cc/img/房庆州.jpg'><p>户主&nbsp;:&nbsp;房庆州&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>政治面貌：群众&nbsp;&nbsp;&nbsp;<br/>在外务工,一般户，<br/>住房等级B,有车，<br/>孝老敬亲户,已改厕<br/>完成双代,美丽庭院</p></div>",
      "properties": {
        "title": "marker"
      }
    },
    {
      "id": maxId + 101,
      "styleId": 'marker1',
      "position": new TMap.LatLng(37.20367763858, 115.46145),
      "tip": "<div><img src='https://www.meiyun.cc/img/房红居.jpg'><p>户主&nbsp;：&nbsp;房红居&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>政治面貌：群众&nbsp;&nbsp;&nbsp;&nbsp;<br/>一般户,住房等级B<br/>孝老敬亲户,已改厕<br/>完成双代,美丽庭院</p></div>",
      "properties": {
        "title": "marker"
      }
    },
    {
      "id": maxId + 102,
      "styleId": 'marker1',
      "position": new TMap.LatLng(37.203862460757954, 115.46064),
      "tip": "<div><img src='https://www.meiyun.cc/img/房建群.jpg'><p>户主&nbsp;:&nbsp;房建群&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>政治面貌：党员&nbsp;&nbsp;&nbsp;&nbsp;<br/>一般户,住房等级B<br/>孝老敬亲户,已改厕<br/>完成双代,美丽庭院</p></div>",
      "properties": {
        "title": "marker"
      }
    },
    {
      "id": maxId + 103,
      "styleId": 'marker1',
      "position": new TMap.LatLng(37.203548263233024, 115.46143029580678),
      "tip": "<div><img src='https://www.meiyun.cc/img/房建锁.jpg'>   <p>户主&nbsp;:&nbsp;房建锁&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>政治面貌：党员&nbsp;&nbsp;&nbsp;&nbsp;<br/>一般户,住房等级B<br/>孝老敬亲户,已改厕<br/>完成双代,美丽庭院</p></div>",
      "properties": {
        "title": "marker"
      }
    }, {
      "id": maxId + 104,
      "styleId": 'marker1',
      "position":  new TMap.LatLng(37.20360992864169, 115.46180156738961),
      "tip": "<div><img src='https://www.meiyun.cc/img/房秀文.jpg'><p>户主&nbsp;:&nbsp;房秀文&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>政治面貌：群众&nbsp;&nbsp;&nbsp;&nbsp;<br/>一般户,住房等级B,<br/>有车，孝老敬亲户<br/>已改厕,美丽庭院。</p></div>",
      "properties": {
        "title": "marker"
      },

    }
  ];
  const geometriesArr = [
    {
      "id": maxId + 100,
      "styleId": 'marker1',
      "position": [37.20400735037333, 115.46126012628055],
      "tip": "<div><img src='https://www.meiyun.cc/img/房庆州.jpg'><p>户主&nbsp;:&nbsp;房庆州&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>政治面貌：群众&nbsp;&nbsp;&nbsp;<br/>在外务工,一般户，<br/>住房等级B,有车，<br/>孝老敬亲户,已改厕<br/>完成双代,美丽庭院</p></div>",
      "properties": {
        "title": "marker"
      }
    },
    {
      "id": maxId + 101,
      "styleId": 'marker1',
      "position": [37.20367763858, 115.46145],
      "tip": "<div><img src='https://www.meiyun.cc/img/房红居.jpg'><p>户主&nbsp;：&nbsp;房红居&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>政治面貌：群众&nbsp;&nbsp;&nbsp;&nbsp;<br/>一般户,住房等级B<br/>孝老敬亲户,已改厕<br/>完成双代,美丽庭院</p></div>",
      "properties": {
        "title": "marker"
      }
    },
    {
      "id": maxId + 102,
      "styleId": 'marker1',
      "position": [37.203862460757954, 115.46064],
      "tip": "<div><img src='https://www.meiyun.cc/img/房建群.jpg'><p>户主&nbsp;:&nbsp;房建群&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>政治面貌：党员&nbsp;&nbsp;&nbsp;&nbsp;<br/>一般户,住房等级B<br/>孝老敬亲户,已改厕<br/>完成双代,美丽庭院</p></div>",
      "properties": {
        "title": "marker"
      }
    },
    {
      "id": maxId + 103,
      "styleId": 'marker1',
      "position": [37.203548263233024, 115.46143029580678],
      "tip": "<div><img src='https://www.meiyun.cc/img/房建锁.jpg'>   <p>户主&nbsp;:&nbsp;房建锁&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>政治面貌：党员&nbsp;&nbsp;&nbsp;&nbsp;<br/>一般户,住房等级B<br/>孝老敬亲户,已改厕<br/>完成双代,美丽庭院</p></div>",
      "properties": {
        "title": "marker"
      }
    }, {
      "id": maxId + 104,
      "styleId": 'marker1',
      "position":  [37.20360992864169, 115.46180156738961],
      "tip": "<div><img src='https://www.meiyun.cc/img/房秀文.jpg'><p>户主&nbsp;:&nbsp;房秀文&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>政治面貌：群众&nbsp;&nbsp;&nbsp;&nbsp;<br/>一般户,住房等级B,<br/>有车，孝老敬亲户<br/>已改厕,美丽庭院。</p></div>",
      "properties": {
        "title": "marker"
      },

    }
  ];
  geometriesArr.forEach((value: { id:any; position:any,tip: any }) => {
    infoWindowData[value.id.toString()] = {
      position: new TMap.LatLng((value.position[0]), value.position[1]),
      phone: '',
      content: value.tip,
    }
  })


  userList.forEach( (item: { id: any; lat: string; lng: string,name: string,phone: string }) => {
    geometries.push({
      id: item.id, //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
      styleId: 'marker', //指定样式id
      tip: '',
      properties: {},
      position: new TMap.LatLng(item.lat, item.lng) //点标记坐标位置
    })
    infoWindowData[item.id.toString()] = {
      position: new TMap.LatLng(item.lat, item.lng),
      phone: item.phone,
      content:`<div><span>${item.name}</span><span class="call" style="padding:5px 10px;background:#04C15F;color:#FFF;border-radius: 5px;font-size: 12px;margin-left: 10px;cursor: pointer" onclick="call()">拨打</span></div>`,
    }
  })
  if(marker){
    marker.setMap(null);
    marker = null;
  }
  marker = new TMap.MultiMarker({
    map: dataMap.map, //指定地图容器
    styles: {
      "marker1": new TMap.MarkerStyle({
        "width": 24,
        "height": 35,
        "anchor": { x: 12, y: 35 },
        "src": 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAiCAYAAABFlhkzAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAKklEQVRIie3NMQEAAAjDMMC/5/FigC8V0HSS+mxe7wAAAAAAAAAAAABwWj6eA0GJx4UtAAAAAElFTkSuQmCCQqFiZg5FgvCNtkymsJwOXbq5nbttvfG5xtl2j+7q++r5c8/n83DP3e/RAEhDOf0AJmVjFgDdSgs1OQQ8U1Qa1tU3e7TVje9WbgSFzMmKZ5UFWwtfL8ZnPM2p2EYJAAetgGf1B0KF5guP1+4WzCvtEAA4p3Bk88ubW6nNsEEukgt4XUOzZ8NVx9OA5dHfnr0Wn/10NlOSKeALG1uH1/tMg3uBk5T0LlyKTY+cJxKGTLDcoUC+cABY7zMNsoaDAdInAr7oWNuTfOEkRea2pwB4ScDqy0OrPcyiWoLVHnaB1ZeHJEHBUetnteAkunqbhwj6tSbze7UFWpP5I4B+BsDkyvXAhtqC5a7FKIBJRvHJPPNfBJZ/yLcwAGB0V2vUJhMmA6A7seQ7p7Zgm9nNAIDwY+qE2oK4z9sEbB9y4udMQ8WLw1VqwY3u6ipxea5WEgBwxKZH2tUSxKaH2yGvpoJv3Mo5BXu+cM651RL/Nm4l/cz/wBEZG+gscyVte4WXudJnImMvryLLhUPCF9u63Gt32NHdwLmHSVtk1N0FhSvzj8R6ZWCtV/eBCu4U7JGxgU45PJcAAPj9pzqGwvdK3+aCG+5HWqPewct/gwO5a5EjOjHUwfXFsx485xTsueBKAkmSbTLqfZ0TTiNAWhR0ZY80TfJx7kGiJZ0U9ymtpynXDmFuYkfFFXze01DYPa0AicBMw46x4Pc6mrVUgrS4pa18VSeV9IrnVQzSKaq1tDeaQwz5a0lHDPmPg+L17EYAMeSvkdor8zXZn9yjIPkraJTa4SXq0q74mZEI81Mni28Cqc2wgfaAAeA3ovDqTTtSBegAAAAASUVORK5CYIK8nb5bydXh9O9DJ2NdznWT7X/jauWIFPa9fxqlLU8KucyxH7c6uTbANGtQmxjqjR2Vwjdvb3h1Y0elsDZ+6hsrlRnkVp6+WwxWKjOojfeHNwqeEwAAsW53RDvb2yN03p8LIHTer52LHM818PMCACD+hndQnxgIw7T7BGO4UTDtPv386e/ir5f154txy9ct1u2OEEEpZ/x65oyDCErzZV4wAACMydEBIgDOGThngCDQLwydLMS3IIA5PX6GQooIziA4gwQpYqpjPxUNoH3ROisRWRZMwOYClMiy/uWj0aIBAIAtzqjEJiA2RWb24kShfoUDlq6ohFBQIoEtXZm+E4BpiUqgVAaLzlwq1C//n+0NxhMLc04if0sppTw+/w9wf3EB6c8eUste/jQk9PiK/tVjy4X6/Qt3BOIMEG4icQAAAABJRU5ErkJggg=='
      })
    },
    //点标记数据数组
    geometries: geometries
  })
  //初始化infoWindow
  infoWindow = new TMap.InfoWindow({
    map: dataMap.map,
    position: center,
    offset: { x: 0, y: -32 }, //设置信息窗相对position偏移像素
    content: '',
  });
  infoWindow.close();//初始关闭信息窗关闭
  marker.on("click",(event: { geometry: { position: { toString: () => any; };id: any }; }) => {
    infoWindow.open();
    if(infoWindowData[event.geometry.id].phone){
      userId = infoWindowData[event.geometry.id].phone;
    }
    infoWindow.setPosition(infoWindowData[event.geometry.id].position)
    infoWindow.setContent(infoWindowData[event.geometry.id].content.toString());//设置信息窗内容
  })


}


const call = ()=> {
  callPhone();
}

window.call= call;

if(interval){
  clearInterval();
}
setTimeout(()=>{
  interval = setInterval(()=>{
    markerLayer();
  },10000)//启动定时器

},1000)



return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_image, {
        style: {"width":"100%"},
        src: require('../assets/top-img.png'),
        fit: "contain"
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_image, {
        style: {"width":"100%"},
        src: require('../assets/left.png'),
        fit: "contain"
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_image, {
        style: {"width":"100%"},
        src: require('../assets/right.png'),
        fit: "contain"
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_image, {
        style: {"width":"100%"},
        src: require('../assets/bottom-l.png'),
        fit: "contain"
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_image, {
        style: {"width":"100%"},
        src: require('../assets/bottom-s.png'),
        fit: "contain"
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_7, null, 512),
    _hoisted_8,
    _createElementVNode("input", {
      type: "hidden",
      value: _unref(showModal)
    }, null, 8, _hoisted_9),
    _createElementVNode("div", {
      class: _normalizeClass('call-kit-container ' +(_unref(showModal) == 1 ? 'z-index' : '') )
    }, [
      _createVNode(_unref(TUICallKit), {
        beforeCalling: beforeCalling,
        afterCalling: afterCalling
      }),
      _createVNode(_unref(TUICallKitMini))
    ], 2)
  ]))
}
}

})